module.exports = __webpack_public_path__ + "img/lot-01.ead72a76.webp";